import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { TracingWokrshopsVO } from 'src/app/shared/vo/TracingWokrshopsVO';
import { Workshops01VO } from 'src/app/shared/vo/Workshops01VO';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';

@Component({
  selector: 'app-tracing-workshops-detail',
  templateUrl: './tracing-workshops-detail.component.html',
  styleUrls: ['./tracing-workshops-detail.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class TracingWorkshopsDetailComponent implements OnInit {

  lstRespTranslate: TranslateRelLabelVO[];
  lbl_period: string = "period_";
  lbl_coordination: string = "coordination_";
  lbl_back: string = "back_";
  lbl_type: string = "type_";
  lbl_service: string = "service_";
  lbl_starting_date: string = "starting_date_";
  lbl_starting_time: string = "starting_time_";
  lbl_ending_time: string = "ending_time_";
  lbl_name_guide_who_taught: string = "name_guide_who_taught_";
  lbl_city: string = "city_";
  lbl_state: string = "state_";
  lbl_country: string = "country_";

  lbl_following_up: string = "following_up_";
  lbl_youngs: string = "youngs_";
  lbl_stages: string = "stages_";
  lbl_children = "children_";
  lbl_adolescents = "adolescents_";

  token: string;
  security: SecurityDocument;
  workShopsTracing: TracingWokrshopsVO;
  workshopList: Workshops01VO[];
  selectedPeriod: PeriodsVO;
  selSerTyp: string;
  selecStores: string;
  blocked: boolean;


  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
    const navigation = this.router.getCurrentNavigation();
    const dataParent = navigation.extras.state;
    if (dataParent) {
      console.debug(dataParent);
      this.workShopsTracing = dataParent.workshop as TracingWokrshopsVO;
      this.token = dataParent.token as string;
      this.selectedPeriod = dataParent.period as PeriodsVO;
      this.selSerTyp = dataParent.selSerTyp as string;
      this.selecStores = dataParent.selecStores as string;
      this.getSecurity();
    } else {
      this.redirectParent();
    }

  }


  getListWorkShopList() {
    console.debug(">>", this.selSerTyp);

    if (!this.selSerTyp || !this.selectedPeriod || !this.workShopsTracing) {
      console.error("Faltan datos necesarios para la petición");
      return;
    }

    const serviceTypeMap: { [key: string]: string[] } = {
      "02": ["02"], "adults": ["02"],
      "03": ["03"], "youngs": ["03"],
      "16": ["16", "17", "18"], "17": ["16", "17", "18"], "18": ["16", "17", "18"], "sfpg": ["16", "17", "18"],
      "04": ["04"], "youngTeens": ["04"],
      "05": ["05"], "children": ["05"]
    };

    const lstSerTyp = serviceTypeMap[this.selSerTyp] || [];

    const payload = {
      year: this.selectedPeriod.year,
      period: this.selectedPeriod.period,
      lstSerTyp,
      storeId: this.workShopsTracing.storeId
    };

    try {
      this.apiService.getTracingListWorkShop(payload)
        .then(data => {
          this.workshopList = data;
          this.messageService.add({
            severity: 'success',
            summary: 'Talleres',
            detail: 'Se actualizó la información correctamente',
            life: 3000
          });
        })
        .catch(error => {
          console.error("Error al obtener talleres:", error);
        });
    } catch (error) {
      console.error("Error inesperado en getListWorkShopList:", error);
    }
  }


  getSecurity() {
    if (this.token) {
      this.apiService.findSecurityById({ "id": this.token }).then(
        data => {
          this.security = data;
          this.getListWorkShopList();
          this.getTranslatedLabels();

        }).catch(error => {
          console.error(error);
        });
    }
  }

  redirectParent() {

    let stores = this.selecStores.split("-");

    this.selecStores = "";
    if (stores.length > 1) {

      for (let ct = 0; ct < stores.length - 1; ct++) {
        this.selecStores = this.selecStores + stores[ct] + "-";
      }
      this.selecStores = this.selecStores.substring(0, this.selecStores.length - 1);
    } else {
      if (this.selecStores == "-") {
        this.selecStores = null;
      } else {
        this.selecStores = null;
      }
    }
    let params = {};
    if (this.workShopsTracing) {
      params["token"] = this.token;
      params["selSerTyp"] = this.selSerTyp;
      params["selecStores"] = this.selecStores;
    }

    const objToSend = { period: this.selectedPeriod }
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(objToSend)),
      queryParams: params
    }

    this.router.navigate(['reports/tracingWorkshops'], navigationExtras);
  }

  ngOnInit(): void {
  }
  getTranslatedLabels() {
    let map = new Map();

    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_back, this.lbl_coordination, this.lbl_period, this.lbl_type, this.lbl_service, this.lbl_starting_date, this.lbl_starting_time, this.lbl_name_guide_who_taught, this.lbl_city, this.lbl_state, this.lbl_country, this.lbl_ending_time]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_period = map.get(this.lbl_period);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_back = map.get(this.lbl_back);
        this.lbl_service = map.get(this.lbl_service);
        this.lbl_starting_date = map.get(this.lbl_starting_date);
        this.lbl_starting_time = map.get(this.lbl_starting_time);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_ending_time = map.get(this.lbl_ending_time);
        this.lbl_name_guide_who_taught = map.get(this.lbl_name_guide_who_taught);
        this.lbl_city = map.get(this.lbl_city);
        this.lbl_state = map.get(this.lbl_state);
        this.lbl_country = map.get(this.lbl_country);
      });
  }

}
